import XMarkdown from '@ant-design/x-markdown'
import { memo } from 'react'

import { markedAlert } from '../markedAlert'
import { useStyles } from '../styles'

import { CodeBlock } from './CodeBlock'
import { LoadingComponents } from './LoadingComponents'
import { useTypewriter } from './useTypewriter'

type Props = {
  content: string
  streaming?: boolean
  breaks?: boolean
}

const markedAlertWithBreaks = { ...markedAlert, breaks: true }

const ChatMarkdownBase = ({ content, streaming = false, breaks }: Props) => {
  const { styles } = useStyles()
  const shownContent = useTypewriter(content, streaming)
  const animating = streaming || shownContent.length < content.length

  return (
    <XMarkdown
      content={shownContent}
      rootClassName={styles.markdown}
      openLinksInNewTab
      escapeRawHtml
      config={breaks ? markedAlertWithBreaks : markedAlert}
      components={{ code: CodeBlock, ...LoadingComponents }}
      streaming={{
        hasNextChunk: animating,
        enableAnimation: animating,
        incompleteMarkdownComponentMap: {
          link: 'loading-link',
          image: 'loading-image'
        }
      }}
    />
  )
}

export const ChatMarkdown = memo(ChatMarkdownBase)
